// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_cOf","cls2":"LoggedInDiscoveryPage-cls2_joT LoggedInDiscoveryPage-cls1_cOf"};